export default __webpack_public_path__ + "static/media/0x65752c54d9102bdfd69d351e1838a1be83c924c6.b0312253.svg";